// extracted by mini-css-extract-plugin
module.exports = {"cover":"_4578","noBottomRadius":"_16659","image":"_5310","sold":"_8107","alert":"_10760"};